import { apiSlice } from "../../app/api/apiSlice";


export const moveLoanApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		moveLoan: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/move_folder/",
				method: "POST",
				body: {
					loan_guid: credentials?.loan_guid,
				},
				
			}),
		}),
	}),
});

export const { useMoveLoanMutation } = moveLoanApiSlice;
